import styles from "./index.module.scss";

const PageDescription = ({ text }) => {
  return (
    <div className={styles.descriptionContainer}>
      <p className={styles.description}>{text}</p>
    </div>
  );
};

export default PageDescription;

